import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';


@Directive({
  selector: '[minValue]',
  providers: [{ provide: NG_VALIDATORS, useExisting: MinValueDirectiveDirective, multi: true }]

})
export class MinValueDirectiveDirective implements Validator{

  @Input('minValue') minValue: number;

  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value !== null && value !== undefined && value < this.minValue) {
      return { minValue: true };
    }
    return null;
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/min-value-directive.directive.ts